import { connect, useDataItem } from 'scrivito'

import { ActivityDataItemTabs } from './Activity/ActivityDataItemTabs'
import { CompanyDataItemTabs } from './Company/CompanyDataItemTabs'
import { DocumentDataItemTabs } from './Document/DocumentDataItemTabs'
import { ListDataItemTabs } from './ListSegment/ListDataItemTabs'
import { OpportunityDataItemTabs } from './Opportunity/OpportunityDataItemTabs'
import { OrderDataItemTabs } from './Order/OrderDataItemTabs'
import { PersonDataItemTabs } from './Person/PersonDataItemTabs'
import { QuoteDataItemTabs } from './Quote/QuoteDataItemTabs'
import { TicketDataItemTabs } from './Ticket/TicketDataItemTabs'
import { DataClassName } from '@/Data/const'

import './DataItemNavTabs.scss'

export const DataItemNavTabs: React.FC = connect(() => {
  const dataItem = useDataItem()
  const dataClassName = dataItem?.dataClassName()

  switch (dataClassName) {
    case DataClassName.ACTIVITY:
      return <ActivityDataItemTabs />
    case DataClassName.COMPANY:
      return <CompanyDataItemTabs />
    case DataClassName.DOCUMENT:
      return <DocumentDataItemTabs />
    case DataClassName.LIST:
      return <ListDataItemTabs />
    case DataClassName.OPPORTUNITY:
      return <OpportunityDataItemTabs />
    case DataClassName.ORDER:
      return <OrderDataItemTabs />
    case DataClassName.PERSON:
      return <PersonDataItemTabs />
    case DataClassName.QUOTE:
      return <QuoteDataItemTabs />
    case DataClassName.TICKET:
      return <TicketDataItemTabs />
    default:
      return null
  }
})
